import $ from 'jquery'
import { algoliasearch } from "algoliasearch";
import instantsearch from 'instantsearch.js'
import { connectInfiniteHits, connectRange } from 'instantsearch.js/es/connectors'
import infiniteHits from '../components/infiniteHits'
import {
  menu,
  configure,
  hierarchicalMenu,
  clearRefinements,
  refinementList, rangeSlider, toggleRefinement,
} from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import {
  connectSearchBox,
  connectCurrentRefinements,
} from 'instantsearch.js/es/connectors'
import { connectHits } from 'instantsearch.js/es/connectors'
import {
  algoliaAppId,
  algoliaApiKey,
  boatSearchIndex,
} from '../variables'
import { boatHit, noResult, boatsButton } from '../templates'
import {dynamicUriTemplate, extractParamsFromUri} from '../functions'
import { lockBody, unlockBody } from '../utils'

// eslint-disable-next-line no-undef
const { __, _n, sprintf } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const {
  boatsMainSlug,
  query,
  boatCondition,
  boatType,
  boatBrand,
  numberPassenger,
  motorPower,
} = object.algoliaQueryStrings

const slugs = {
  query,
  boatCondition,
  boatType,
  boatBrand,
  numberPassenger,
  motorPower,
}

let boatsSearch
const checkEl = document.querySelector('.pt-boats__hits')
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)

  boatsSearch = instantsearch({
    indexName: boatSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      // Rewrite and create slugs with our options
      router: history({
        cleanUrlOnDispose: false,
        createURL({ location, routeState }) {
          const params = {
            query: routeState.query,
            boatCondition: routeState.boatCondition,
            boatType: routeState.boatType,
            boatBrand: routeState.boatBrand,
            numberPassenger: routeState.numberPassenger,
            motorPower: routeState.motorPower,
          }

          return dynamicUriTemplate(location.origin, params, boatsMainSlug, slugs)
        },

        parseURL({ location }) {
          const params = extractParamsFromUri(location.href, slugs)

          return {
            query: params[slugs.query] && params[slugs.query][0],
            boatCondition: params[slugs.boatCondition],
            boatType: params[slugs.boatType],
            boatBrand: params[slugs.boatBrand],
            numberPassenger: params[slugs.numberPassenger],
            motorPower: params[slugs.motorPower],
          }
        },
      }),

      // Rewrite and create slugs with our options
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[boatSearchIndex] || {}

          return {
            query: indexUiState.query,
            boatCondition: indexUiState.refinementList?.['boatCondition.name'],
            boatType: indexUiState.refinementList?.['boatType.name'],
            boatBrand: indexUiState.hierarchicalMenu?.['boatBrand.lvl0'],
            numberPassenger: indexUiState.range?.['passengersCapacity'],
            motorPower: indexUiState.range?.['maxPowerHp'],
          }
        },

        routeToState(routeState) {
          var passengersCapacityValue = '';
          if ( routeState.numberPassenger ) {
            passengersCapacityValue = routeState.numberPassenger[0];
          }

          var maxPowerHpValue = '';
          if ( routeState.motorPower ) {
            maxPowerHpValue = routeState.motorPower[0];
          }

          return {
            [boatSearchIndex]: {
              query: routeState.query,
              refinementList: {
                'boatCondition.name': routeState.boatCondition,
                'boatType.name': routeState.boatType,
              },
              hierarchicalMenu: {
                'boatBrand.lvl0': routeState.boatBrand,
              },
              range: {
                passengersCapacity: passengersCapacityValue,
                maxPowerHp: maxPowerHpValue,
              },
            },
          }
        },
      },
    },
  })

  const boatItem = ({ hits, sendEvent, widgetParams }) => {
    const container = document.querySelector(widgetParams.container)

    container.innerHTML = `
      ${
        hits.length
            ? hits
                .map((item) => {
                  return boatHit(item, 'g-col-12 g-col-md-6 g-col-lg-4')
                })
                .join('')
            : noResult
    }
  `

    container.querySelectorAll('.feed-boat__wrapper')
        .forEach((element, index) => {
          element.addEventListener('click', (event) => {
            sendEvent('click', hits[index], 'Boat Clicked')
          })
        })
  }

  const boatItems = connectHits(boatItem)

  const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, clear, isSearchStalled, widgetParams } =
        renderOptions
    const container = document.querySelector(widgetParams.container)

    if (isFirstRender) {
      const input = document.createElement('input')
      input.type = 'search'
      input.placeholder = widgetParams.placeholder

      container.insertAdjacentHTML('beforeend', object.loader)

      const reset = document.createElement('button')
      reset.type = 'reset'
      reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

      const submit = document.createElement('button')
      submit.type = 'submit'
      submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

      input.addEventListener('input', (boat) => {
        refine(boat.target.value)
      })

      reset.addEventListener('click', () => {
        clear()
      })

      container.appendChild(input)
      container.appendChild(reset)
      container.appendChild(submit)
    }

    container.querySelector('input').value = query
    container.querySelector('.vn-loader').hidden = !isSearchStalled
    container.querySelector('button[type="reset"]').hidden =
        isSearchStalled || !query
    container.querySelector('button[type="submit"]').hidden = isSearchStalled
  }

  const customSearchBox = connectSearchBox(renderSearchBox)
  const customInfiniteHits = connectInfiniteHits(
      infiniteHits(boatHit, boatsButton)
  )

  const renderCurrentRefinements = ({ items, widgetParams }) => {
    const container = document.querySelector(widgetParams.container)
    const totalItemCount = items.reduce(
        (acc, curr) => acc + curr.refinements.length,
        0
    )

    container.innerHTML = sprintf(
        _n('%s active filter', '%s active filters', totalItemCount, 'vn'),
        totalItemCount
    )
  }

  const customCurrentRefinements = connectCurrentRefinements(
      renderCurrentRefinements
  )

  boatsSearch.addWidgets([

    customSearchBox({
      container: '.pt-boats__search-handler',
      placeholder: __('Search a boat', 'vn'),
      showLoadingIndicator: false,
    }),

    clearRefinements({
      container: '.pt-boats__reset-handler',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<div class="vn-btn vn-btn--primary"
            >${hasRefinements
              ? __('Reset filters', 'vn')
              : __('No filters', 'vn')}</div
          >`
        },
      },
    }),

    hierarchicalMenu({
      container: '.pt-boats__boat-brands-handler',
      attributes: [
        'boatBrand.lvl0',
        'boatBrand.lvl1',
      ],
      sortBy: ['name'],
      limit: 999,
    }),

    refinementList({
      container: '.pt-boats__boat-condition-handler',
      attribute: 'boatCondition.name',
      limit: 99,
      sortBy: ['name:asc'],
    }),

    refinementList({
      container: '.pt-boats__boat-type-handler',
      attribute: 'boatType.name',
      limit: 99,
      sortBy: ['name:asc'],
    }),

    rangeSlider({
      container: '.pt-boats__passenger-handler',
      attribute: 'passengersCapacity',
    }),

    rangeSlider({
      container: '.pt-boats__power-handler',
      attribute: 'maxPowerHp',
    }),

    customInfiniteHits({
      container: document.querySelector('.pt-boats__hits'),
    }),

    configure({
      hitsPerPage: 21,
    }),
  ])

  boatsSearch.start()
}

export { boatsSearch }

$('.js-open-algolia-filters').on('click', function (e) {
  $('.js-algolia-filters').fadeIn()
  lockBody()
})

$('.js-close-algolia-filters').on('click', function (e) {
  $('.js-algolia-filters').fadeOut()
  unlockBody()
})
